"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var TopicLabel = function TopicLabel(_ref) {
  var topic = _ref.topic;
  var contentType = topic.contentType,
      publicLabel = topic.publicLabel;

  if (!contentType === 'article' || !contentType === 'product_update' || !publicLabel) {
    return null;
  }

  return (0, _preact.h)("span", {
    className: (0, _classnames.default)('thread__content-type-pill', 'pill', 'pill--uppercase', 'pill--article', 'qa-content-type-pill')
  }, publicLabel);
};

var _default = TopicLabel;
exports.default = _default;